var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearbitIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ClearbitIcon_svg__[object_Object]a",
    d: "M4.273 0h7.454c1.486 0 2.025.155 2.568.445.543.29.97.717 1.26 1.26.29.543.445 1.082.445 2.568v7.454c0 1.486-.155 2.025-.445 2.568-.29.543-.717.97-1.26 1.26-.543.29-1.082.445-2.568.445H4.273c-1.486 0-2.025-.155-2.568-.445a3.029 3.029 0 01-1.26-1.26C.155 13.752 0 13.213 0 11.727V4.273c0-1.486.155-2.025.445-2.568.29-.543.717-.97 1.26-1.26C2.248.155 2.787 0 4.273 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ClearbitIcon_svg__[object_Object]b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ClearbitIcon_svg__[object_Object]a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#3386EE",
    xlinkHref: "#ClearbitIcon_svg__[object_Object]a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#61ADF7",
    mask: "url(#ClearbitIcon_svg__[object_Object]b)",
    d: "M8 0h8v16H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F9FE",
    mask: "url(#ClearbitIcon_svg__[object_Object]b)",
    d: "M8 8h8v8H8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearbitIcon);
export default ForwardRef;